<ion-header class="{{themeService.isDarkMode ? 'dark': 'light'}}">
  <ion-toolbar> 
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <app-search-teams mode="md" (teams)="searchedTeams($event)"></app-search-teams>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (teams?.length > 0) {
    @for (team of teams; track team._id;) {
      <app-team-item [team]="team" (click)="close(team)" ></app-team-item>
    }
  } @else {
    <app-empty-page [text]="emptyPagePlaceholder" iconName="people"></app-empty-page>
  }

</ion-content>